import { Plugin, PluginKey } from 'prosemirror-state';
import { ContentChangedEvent } from './text-changed-event';
import { Subscriber } from 'rxjs';
import { SelectEvent } from './select-event';
import { ShortcutEvent } from './shortcut-event';
import { TextFormatAttribute } from './select-event-attribute';
import { TextFormats } from '../../menu/text-formats';
import { wrapInList } from "prosemirror-schema-list";
class EventHandler {
    contentChangeEventSubscriber: Subscriber<ContentChangedEvent>;
    selectionEventSubscriber: Subscriber<SelectEvent>;

    constructor(contentChangeEventSubscriber, selectionEventSubscriber: Subscriber<SelectEvent>) {
        this.contentChangeEventSubscriber = contentChangeEventSubscriber;
        this.selectionEventSubscriber = selectionEventSubscriber;
    }

    update(view, lastState) {
        const self = this;
        const state = view.state;
        /* verifico se il documento e' cambiato */
        if (lastState && !lastState.doc.eq(state.doc) && this.contentChangeEventSubscriber) {
            const event = new ContentChangedEvent();
            event.text = state.doc.textContent;
            event.innerHTML = view.dom.innerHTML;
            const startPos = state.selection.$from.start();
            const endPos = state.selection.$from.end();
            event.currentPargraphStartPos = startPos;
            event.currentPargraphEndPos = endPos;
            if (startPos !== endPos) {
                event.currentParagraphText = state.doc.textBetween(startPos, endPos);
            }
            event.redoCount = state.history$.done.eventCount;
            event.undoCount = state.history$.undone.eventCount;
            this.contentChangeEventSubscriber.next(event);
        }
        /* verifico se l'utente ha selezionato qualcosa */
        if (this.selectionEventSubscriber != null) {
            const textSelectedEvent: SelectEvent = new SelectEvent();
            textSelectedEvent.startPos = state.selection.from;
            textSelectedEvent.endPos = state.selection.to;
            if (state.selection.from !== state.selection.to) {
                textSelectedEvent.text = state.doc.textBetween(state.selection.from, state.selection.to, ' ');
            }
            textSelectedEvent.nodeAttrs = {};

            let nodesMarks = [];
            const childCount = state.selection.$from.node(1)?.childCount;
            const isAtStart = (!state.selection.$from.nodeBefore);
            const isAtEnd = (!state.selection.$from.nodeAfter);

            if (state.selection.from === state.selection.to) {
                if (isAtStart) {

                    if (isAtEnd && childCount > 1) {
                        const indexNodeBefore = (childCount - 2);
                        const textNodeBefore = state.selection.$from.node(1).child(indexNodeBefore).lastChild;
                        const nodeMarks = self.extractMarkNames(textNodeBefore);
                        nodesMarks.push(nodeMarks);
                    } else {
                        const nodeMarks = self.extractMarkNames(state.selection.$from.nodeAfter);
                        nodesMarks.push(nodeMarks);
                    }
                } else {
                    const nodeMarks = self.extractMarkNames(state.selection.$from.nodeBefore);
                    nodesMarks.push(nodeMarks);
                }
            }
            state.doc.nodesBetween(state.selection.from, state.selection.to, function (node) {
                if (node.isText) {
                    const nodeMarks = self.extractMarkNames(node);
                    nodesMarks.push(nodeMarks);
                } else {
                    if (Object.keys(node.attrs).length !== 0 && node.attrs.constructor !== Object) {
                        textSelectedEvent.nodeAttrs = node.attrs;
                    }
                }
            });
            nodesMarks = this.extractCommonMarks(nodesMarks);

            /* Verifico i mark comuni e per ogni possibile text format (i.e. bold, italic..)
            inserisco true o false */
            const textFormatAttributes: TextFormatAttribute[] = new Array();
            for (const format in TextFormats) {
                if (TextFormats.hasOwnProperty(format)) {
                    const name: TextFormats = TextFormats[format] as TextFormats;
                    const value = (nodesMarks.indexOf(name) > -1);
                    const attr: TextFormatAttribute = { name, value };
                    textFormatAttributes.push(attr);
                }
            }

            textSelectedEvent.textFormatAttributes = textFormatAttributes;
            textSelectedEvent.isList = this.getListType(state);
            this.selectionEventSubscriber.next(textSelectedEvent);
        }
    }


    getListType(state) {
        let listType = '';
        const isInList = !wrapInList(state.schema.nodes.bullet_list)(state);
        if (isInList) {
            switch (state.selection.$from.node(2)?.type.name) {
                case 'bullet_list':
                    listType = 'unordered';
                    break;
                case 'ordered_list':
                    listType = 'ordered';
                    break;
            }
        }
        return listType;
    }

    extractMarkNames(node) {
        const nodeMarks = [];
        if (node) {
            const marks = node.marks;
            if (Object.keys(marks).length !== 0) {
                for (const field of Object.keys(marks)) {
                    nodeMarks.push(marks[field].type.name);
                }
            }
        }
        return nodeMarks;
    }

    extractCommonMarks(args) {
        const result = [];
        let lists;
        if (arguments.length === 1) {
            lists = arguments[0];
        } else {
            lists = arguments;
        }

        for (let currentList of lists) {
            for (let currentValue of currentList) {
                if (result.indexOf(currentValue) === -1) {
                    if (lists.filter(function (obj) { return obj.indexOf(currentValue) === -1; }).length === 0) {
                        result.push(currentValue);
                    }
                }
            }
        }

        return result;
    }

}

export function documentEventHandlerPlugin(contentChangeSubscriber: Subscriber<ContentChangedEvent>, selectionEventSubscriber: Subscriber<SelectEvent>) {
    return new Plugin({
        key: new PluginKey('documentEventHandlerPlugin'),
        view() {
            return new EventHandler(contentChangeSubscriber, selectionEventSubscriber);
        }
    });
}

export function documentTouchedEventHandler(subscriber: Subscriber<boolean>) {
    if (subscriber) {
        subscriber.next(true);
    }
}

export function buildShortcutKeyMap(shortcutEventSubscriber: Subscriber<ShortcutEvent>, shortcutList: string[]) {
    const shortcutKeymap = {};
    shortcutList.forEach(
        shortcut => {
            shortcutKeymap[shortcut] = function () {
                /* each time the shortcut is detected the subscriber is invoked */
                const event = new ShortcutEvent();
                event.shortcut = shortcut;
                shortcutEventSubscriber.next(event);
                return true; // event handled - others are not called
            };
        }
    );
    return shortcutKeymap;
}
